import { isGtmEnabled, trackGtmEvent } from '@motionelements/core/src/helpers/gtm.js';

export default {
    methods: {
        trackExperimentImpression(experimentId, variant) {
            if (isGtmEnabled(this)) {
                window.dataLayer.push({
                    experimentId: experimentId,
                    variantId: `${experimentId}.${variant}`,
                });

                trackGtmEvent(this, {
                    event: 'experiment_impression',
                    // 'experiment_id': '$experimentId1',
                    // 'variant_id': '$experimentId1.1-0',
                });
            }
        },
    },
};
